import { Chip, type ChipProps } from '@mui/material';

/**
 * Durum çipi — bugüne kadar her sayfada kopyalanan
 * `<Chip size="small" color={x.isActive ? 'success' : 'default'} label={...} />`
 * kalıbının tek yeri. `active` kısayolu bugünkü çıktının birebir aynısını verir
 * (success/default renk + "Aktif"/"Pasif"); `tone` + `label` yeni kullanımlar için.
 */
export type StatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'pending';

const TONE_COLOR: Record<StatusTone, ChipProps['color']> = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
  neutral: 'default',
  pending: 'warning',
};

export interface StatusChipProps {
  label?: string;
  tone?: StatusTone;
  /** Kısayol: `true` → success "Aktif", `false` → neutral "Pasif". */
  active?: boolean;
  size?: ChipProps['size'];
  variant?: 'filled' | 'outlined';
}

export function StatusChip({ label, tone, active, size = 'small', variant = 'filled' }: StatusChipProps) {
  const resolvedTone: StatusTone = tone ?? (active === undefined ? 'neutral' : active ? 'success' : 'neutral');
  const resolvedLabel = label ?? (active === undefined ? '' : active ? 'Aktif' : 'Pasif');
  return <Chip size={size} variant={variant} color={TONE_COLOR[resolvedTone]} label={resolvedLabel} />;
}

/** Yaygın Türkçe durum metinlerini bir tona eşler — `<StatusChip {...statusChipProps(s)} />`. */
export function statusChipProps(value: string | null | undefined): StatusChipProps {
  const v = (value ?? '').toLocaleLowerCase('tr');
  if (!v) return { label: '—', tone: 'neutral' };
  if (/(aktif|onayl|tamamland|başarı|ödendi|kesinleş|biletlen)/.test(v)) return { label: value!, tone: 'success' };
  if (/(bekle|onay bekliyor|ön rezerv|kısmi|işlemde)/.test(v)) return { label: value!, tone: 'pending' };
  if (/(iptal|hata|başarısız|reddedil|pasif)/.test(v)) return { label: value!, tone: 'error' };
  return { label: value!, tone: 'neutral' };
}
